// import React, { useState } from "react";
// import { Box, IconButton, Paper } from "@mui/material";
// import { MdSend } from "react-icons/md";

// export const  MessageInput = ({ onSend }) => {
//   const [text, setText] = useState("");

//   const send = () => {
//     if (text.trim()) {
//       onSend(text);
//       setText("");
//     }
//   };

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         p: 1,
//         display: "flex",
//         alignItems: "center",
//         bgcolor: "#f0f0f0", // light grey bar
//       }}
//     >
//       <Box
//         component="input"
//         placeholder="Type a message"
//         value={text}
//         onChange={(e) => setText(e.target.value)}
//         onKeyDown={(e) => e.key === "Enter" && send()}
//         sx={{
//           flex: 1,
//           border: "none",
//           outline: "none",
//           px: 2,
//           py: 1.2,
//           mr: 1,
//           borderRadius: 25,
//           fontSize: "0.95rem",
//           backgroundColor: "#fff", // white input like WhatsApp
//           boxShadow: "inset 0 1px 2px rgba(0,0,0,0.05)",
//         }}
//       />
//       <IconButton
//         onClick={send}
//         sx={{
//           bgcolor: "#006a4e", // WhatsApp green
//           color: "#fff",
//           width: 45,
//           height: 45,
//           "&:hover": { bgcolor: "#006a4e" },
//         }}
//       >
//         <MdSend size={22} />
//       </IconButton>
//     </Paper>
//   );
// }

import {
  Backdrop,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import axios from 'axios';
import { isEmpty, map, sortBy } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import {
  MdCameraAlt,
  MdClose,
  MdFlipCameraAndroid,
  MdSend,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import Webcam from 'react-webcam';
import { dataURLtoFile, getAddressFromCoords } from '../common';
import fileUploadService from '../services/fileUploadService';

export const MessageInput = ({
  onSend,
  disabled,
  selectedUsers,
  onSelect,
  users,
  isCuChat,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [text, setText] = useState('');
  const [attachments, setAttachments] = useState([]); // [{url, name}]
  const [uploading, setUploading] = useState(false);
  const [dropdown1, setDropdown1] = useState('');
  const [dropdown2, setDropdown2] = useState('');
  const [dropdown3, setDropdown3] = useState('');
  const [medicalList, setMedicalList] = useState([]);
  const webcamRef = useRef(null);
  const [openCamera, setOpenCamera] = useState(false);
  const [loading, setLoading] = useState(false); // add at top of your componen

  const capturePhoto = async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setLoading(true);

    try {
      const coords = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos.coords),
          reject
        )
      );

      const address = await getAddressFromCoords(
        coords.latitude,
        coords.longitude
      );

      const img = new Image();
      img.src = imageSrc;
      img.onload = async () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');

        // Draw original photo
        ctx.drawImage(img, 0, 0);

        // Lines to display
        const lines = [
          address,
          `Lat: ${coords.latitude.toFixed(5)} | Lng: ${coords.longitude.toFixed(
            5
          )}`,
          new Date().toLocaleString(),
        ];

        ctx.font = isMobile ? '10px Arial' : '16px Arial';
        const padding = 10;
        const lineHeight = 18;

        // Map and text sizing
        const mapWidth = isMobile ? 140 : 200;
        const textWidth = canvas.width - mapWidth - padding * 3;
        const boxHeight = Math.max(
          lineHeight * lines.length + padding * 2,
          100
        );
        const y = canvas.height - boxHeight;

        // Draw black background
        ctx.fillStyle = 'rgba(0,0,0,0.7)';
        ctx.fillRect(0, y, canvas.width, boxHeight);

        const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

        // Try loading the map
        try {
          const mapImg = new Image();
          mapImg.crossOrigin = 'Anonymous';
          mapImg.src = staticMapUrl;
          mapImg.onload = () => {
            const mapBottomPadding = 10;
            ctx.drawImage(
              mapImg,
              padding,
              y,
              mapWidth,
              boxHeight - mapBottomPadding
            );

            drawTextAndExport();
          };

          mapImg.onerror = () => {
            console.warn(
              'Static map failed to load. Proceeding without map overlay.'
            );
            drawTextAndExport(); // fallback
          };
        } catch (mapError) {
          console.error('Error loading static map:', mapError);
          drawTextAndExport(); // fallback if something goes wrong in map loading
        }

        // Function to draw text + export
        function drawTextAndExport() {
          ctx.fillStyle = 'white';
          ctx.textAlign = 'left';
          const textX = mapWidth + padding * 2;
          let textY = y + padding;

          lines.forEach((line) => {
            const words = line?.split(' ') || [];
            let lineText = '';
            words.forEach((word) => {
              const testLine = lineText + word + ' ';
              const metrics = ctx.measureText(testLine);
              if (metrics.width > textWidth) {
                ctx.fillText(lineText, textX, textY);
                lineText = word + ' ';
                textY += lineHeight;
              } else {
                lineText = testLine;
              }
            });
            ctx.fillText(lineText, textX, textY);
            textY += lineHeight;
          });

          const stampedDataURL = canvas.toDataURL('image/jpeg');
          const stampedFile = dataURLtoFile(
            stampedDataURL,
            `photo_${Date.now()}.jpg`
          );
          handleFileChange(stampedFile);
        }
      };
    } catch (e) {
      console.error('Error capturing photo:', e);
      setLoading(false);
    }
  };

  // const capturePhoto = async () => {
  //   const imageSrc = webcamRef.current.getScreenshot();
  //   setLoading(true);

  //   try {
  //     const coords = await new Promise((resolve, reject) =>
  //       navigator.geolocation.getCurrentPosition(
  //         (pos) => resolve(pos.coords),
  //         reject
  //       )
  //     );

  //     const address = await getAddressFromCoords(
  //       coords.latitude,
  //       coords.longitude
  //     );

  //     const img = new Image();
  //     img.src = imageSrc;
  //     img.onload = async () => {
  //       const canvas = document.createElement('canvas');
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext('2d');

  //       // Draw original photo
  //       ctx.drawImage(img, 0, 0);

  //       // Lines to display
  //       const lines = [
  //         address,
  //         `Lat: ${coords.latitude.toFixed(5)} | Lng: ${coords.longitude.toFixed(
  //           5
  //         )}`,
  //         new Date().toLocaleString(),
  //       ];

  //       ctx.font = isMobile ? '10px Arial' : '16px Arial';
  //       const padding = 10;
  //       const lineHeight = 18;

  //       // Map and text sizing
  //       const mapWidth = isMobile ? 140 : 200;
  //       const textWidth = canvas.width - mapWidth - padding * 3;
  //       const boxHeight = Math.max(
  //         lineHeight * lines.length + padding * 2,
  //         100
  //       );
  //       const y = canvas.height - boxHeight;

  //       // Draw black background
  //       ctx.fillStyle = 'rgba(0,0,0,0.7)';
  //       ctx.fillRect(0, y, canvas.width, boxHeight);

  //       // Draw static map
  //       const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
  //       const mapImg = new Image();
  //       mapImg.crossOrigin = 'Anonymous';
  //       mapImg.src = staticMapUrl;
  //       mapImg.onload = () => {
  //         const mapBottomPadding = 10; // extra space below map
  //         ctx.drawImage(
  //           mapImg,
  //           padding,
  //           y,
  //           mapWidth,
  //           boxHeight - mapBottomPadding
  //         );

  //         // Draw wrapped text on right
  //         ctx.fillStyle = 'white';
  //         ctx.textAlign = 'left';
  //         const textX = mapWidth + padding * 2;
  //         let textY = y + padding;

  //         lines.forEach((line) => {
  //           // Wrap long lines
  //           const words = line?.split(' ');
  //           let lineText = '';
  //           words.forEach((word) => {
  //             const testLine = lineText + word + ' ';
  //             const metrics = ctx.measureText(testLine);
  //             if (metrics.width > textWidth) {
  //               ctx.fillText(lineText, textX, textY);
  //               lineText = word + ' ';
  //               textY += lineHeight;
  //             } else {
  //               lineText = testLine;
  //             }
  //           });
  //           ctx.fillText(lineText, textX, textY);
  //           textY += lineHeight;
  //         });

  //         // Export stamped image
  //         const stampedDataURL = canvas.toDataURL('image/jpeg');
  //         const stampedFile = dataURLtoFile(
  //           stampedDataURL,
  //           `photo_${Date.now()}.jpg`
  //         );
  //         handleFileChange(stampedFile);
  //       };
  //     };
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  const handleFileChange = async (file) => {
    const res = await fileUploadService?.handleFileUpload(file);
    if (res?.status === 200) {
      const uploadedURL = `${res?.data?.filename}`;
      setAttachments((prev) => [...prev, uploadedURL]);
      setOpenCamera(false);
    }
    setLoading(false);
  };

  // const addGeoTagToImage = async (file, coords) => {
  //   const dataUrl = await new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = () => resolve(reader.result);
  //     reader.onerror = reject;
  //     reader.readAsDataURL(file);
  //   });

  //   const loadImage = (src) =>
  //     new Promise((resolve, reject) => {
  //       const img = new Image();
  //       img.crossOrigin = 'Anonymous';
  //       img.onload = () => resolve(img);
  //       img.onerror = reject;
  //       img.src = src;
  //     });

  //   const img = await loadImage(dataUrl);
  //   const address = await getAddressFromCoords(
  //     coords.latitude,
  //     coords.longitude
  //   );

  //   const canvas = document.createElement('canvas');
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   const ctx = canvas.getContext('2d');

  //   ctx.drawImage(img, 0, 0);

  //   // Dynamic sizing
  //   const padding = Math.round(canvas.width * 0.02); // 2% of width
  //   const boxHeight = Math.round(canvas.height * 0.2); // 20% of image height
  //   const mapWidth = Math.round(boxHeight * 1.3); // make map rectangle
  //   const y = canvas.height - boxHeight;

  //   // Background
  //   ctx.fillStyle = 'rgba(0,0,0,0.7)';
  //   ctx.fillRect(0, y, canvas.width, boxHeight);

  //   // Load map
  //   const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

  //   try {
  //     const mapImg = await loadImage(staticMapUrl);
  //     ctx.drawImage(mapImg, padding, y, mapWidth, boxHeight);
  //   } catch (err) {
  //     console.warn('Map failed to load', err);
  //   }

  //   // Draw text on right
  //   const lines = [
  //     address || '',
  //     `Lat: ${coords.latitude.toFixed(5)} | Lng: ${coords.longitude.toFixed(
  //       5
  //     )}`,
  //     new Date().toLocaleString(),
  //   ];

  //   const fontSize = Math.max(Math.round(canvas.width * 0.015), 16);
  //   ctx.fillStyle = 'white';
  //   ctx.font = `${fontSize}px Arial`;
  //   ctx.textAlign = 'left';

  //   const textX = mapWidth + 2 * padding;
  //   let textY = y + padding;
  //   const textWidth = canvas.width - mapWidth - 3 * padding;
  //   const lineHeight = Math.round(fontSize * 1.4);

  //   lines.forEach((line) => {
  //     const words = line.split(' ');
  //     let lineText = '';
  //     words.forEach((word) => {
  //       const testLine = lineText + word + ' ';
  //       const metrics = ctx.measureText(testLine);
  //       if (metrics.width > textWidth) {
  //         ctx.fillText(lineText, textX, textY);
  //         lineText = word + ' ';
  //         textY += lineHeight;
  //       } else {
  //         lineText = testLine;
  //       }
  //     });
  //     ctx.fillText(lineText, textX, textY);
  //     textY += lineHeight;
  //   });

  //   return new Promise((resolve) =>
  //     canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9)
  //   );
  // };

  // // main handler
  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   try {
  //     setUploading(true);

  //     const position = await new Promise((resolve, reject) =>
  //       navigator.geolocation.getCurrentPosition(resolve, reject)
  //     );
  //     const coords = position.coords;

  //     const geotaggedBlob = await addGeoTagToImage(file, coords);

  //     console.log('file', file);

  //     const generateUniqueId = () => {
  //       return `${Date.now()}_${Math.random().toString(36).substr(2, 6)}`;
  //     };

  //     const nameWithoutExt = file?.name.replace(/\.[^/.]+$/, '');

  //     const geotaggedFile = new File(
  //       [geotaggedBlob],
  //       `${nameWithoutExt}_${generateUniqueId()}.jpg`,
  //       { type: 'image/jpeg' }
  //     );

  //     const res = await fileUploadService?.handleFileUpload(geotaggedFile);
  //     if (res?.status === 200 && res?.data?.filename) {
  //       setAttachments((prev) => [...prev, res.data.filename]);
  //     } else {
  //       console.error('Upload failed', res);
  //     }
  //   } catch (err) {
  //     console.error('Error uploading file:', err);
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   try {
  //     setUploading(true); // start loading
  //     const res = await fileUploadService?.handleFileUpload(file);
  //     if (res?.status === 200 && res?.data?.filename) {
  //       setAttachments((prev) => [...prev, res.data.filename]);
  //     } else {
  //       console.error('Upload failed', res);
  //     }
  //   } catch (err) {
  //     console.error('Error uploading file:', err);
  //   } finally {
  //     setUploading(false); // end loading
  //   }
  // };

  const removeAttachment = (index) => {
    setAttachments((prev) => prev.filter((a, ind) => index !== ind));
  };

  const send = () => {
    if (!text) {
      toast.error('PLEASE ENTER MESSAGE!!');
    } else {
      onSend({
        text,
        attachments: attachments,
        dropdown1,
        dropdown2,
        dropdown3,
      });
      setText('');
      setAttachments([]);
      setDropdown1('');
      setDropdown2('');
      setDropdown3('');
    }
  };

  const gpsUnitMedical = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/gps_unit/medicalunits`
    );
    if (res?.status === 200) {
      setMedicalList(sortBy(res?.data,'name'));
    }
  };

  useEffect(() => {
    if (isCuChat) {
      gpsUnitMedical();
    }
  }, [isCuChat]);

  // Toggle all users
  const toggleSelectAll = () => {
    if (selectedUsers?.length === users?.length) {
      onSelect([]); // deselect all
    } else {
      onSelect(users); // select all
    }
  };

  const allSelected =
    selectedUsers?.length === users?.length && users?.length > 0;

  return (
    // <Paper
    //   elevation={3}
    //   sx={{
    //     p: 1,
    //     display: 'flex',
    //     alignItems: 'center',
    //     bgcolor: '#f0f0f0',
    //     flexWrap: 'wrap',
    //     gap: 1,
    //   }}
    // >
    //   {/* Attachments preview */}
    //   {attachments.length > 0 && (
    //     <Box
    //       sx={{
    //         width: '100%',
    //         display: 'flex',
    //         gap: 1,
    //         flexWrap: 'wrap',
    //         px: 1,
    //       }}
    //     >
    //       {attachments.map((file, idx) => {
    //         return (
    //           <Box
    //             key={idx}
    //             sx={{
    //               position: 'relative',
    //               width: 50,
    //               height: 50,
    //               borderRadius: 2,
    //               overflow: 'hidden',
    //               border: '1px solid #e0e0e0',
    //               display: 'flex',
    //               alignItems: 'center',
    //               justifyContent: 'center',
    //               bgcolor: '#fafafa',
    //               boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    //               transition: 'transform 0.2s ease-in-out',
    //               '&:hover': {
    //                 transform: 'scale(1.05)',
    //                 boxShadow: '0 3px 6px rgba(0,0,0,0.15)',
    //               },
    //             }}
    //           >
    //             {/* Image */}
    //             <img
    //               src={`${process.env.REACT_APP_IMAGE_URL}/images/${file}`}
    //               alt={file}
    //               style={{
    //                 width: '100%',
    //                 height: '100%',
    //                 objectFit: 'contain',
    //                 borderRadius: 'inherit',
    //               }}
    //             />

    //             {/* Remove icon */}
    //             <IconButton
    //               size='small'
    //               onClick={() => removeAttachment(idx)}
    //               sx={{
    //                 position: 'absolute',
    //                 top: 4,
    //                 right: 4,
    //                 bgcolor: 'rgba(255,255,255,0.8)',
    //                 color: '#333',
    //                 width: 22,
    //                 height: 22,
    //                 boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    //                 p: 0,
    //                 '&:hover': {
    //                   bgcolor: 'rgba(255,255,255,1)',
    //                   color: '#d32f2f',
    //                 },
    //               }}
    //             >
    //               ✕
    //             </IconButton>
    //           </Box>
    //         );
    //       })}
    //     </Box>

    //     // <Box
    //     //   sx={{
    //     //     width: '100%',
    //     //     display: 'flex',
    //     //     gap: 1,
    //     //     flexWrap: 'wrap',
    //     //     px: 1,
    //     //   }}
    //     // >
    //     //   {attachments.map((file, idx) => (
    //     //     <Chip
    //     //       key={idx}
    //     //       label={
    //     //         <Typography noWrap sx={{ maxWidth: 100 }}>
    //     //           {file}
    //     //         </Typography>
    //     //       }
    //     //       onDelete={() => removeAttachment(file.url)}
    //     //       sx={{ maxWidth: 150 }}
    //     //     />
    //     //   ))}
    //     // </Box>
    //   )}

    //   {/* File input */}
    //   {/* <input
    //     type='file'
    //     id='fileInput'
    //     multiple
    //     style={{ display: 'none' }}
    //     onChange={handleFileChange}
    //   />
    //   <IconButton component='label' htmlFor='fileInput' sx={{ color: '#555' }}>
    //     {uploading ? (
    //       <CircularProgress size={20} />
    //     ) : (
    //       <MdAttachFile size={22} />
    //     )}
    //   </IconButton> */}

    //   <input
    //     type='file'
    //     id='fileInput'
    //     accept='image/*' // images only
    //     capture // opens camera UI with flip/flash etc.
    //     style={{ display: 'none' }}
    //     onChange={handleFileChange}
    //   />

    //   <IconButton component='label' htmlFor='fileInput' sx={{ color: '#555' }}>
    //     {uploading ? <CircularProgress size={20} /> : <MdCameraAlt size={22} />}
    //   </IconButton>

    //   {/* Dropdown 1 */}
    //   <FormControl
    //     size='small'
    //     sx={{
    //       minWidth: 110,
    //       '& .MuiOutlinedInput-root': {
    //         borderRadius: '25px',
    //         backgroundColor: '#fff',
    //       },
    //     }}
    //   >
    //     {!dropdown1 && (
    //       <InputLabel
    //         id='dropdown1-label'
    //         sx={{
    //           top: '-2px',
    //           left: '5px',
    //           fontSize: '0.875rem',
    //         }}
    //       >
    //         Option 1
    //       </InputLabel>
    //     )}
    //     <Select
    //       labelId='dropdown1-label'
    //       value={dropdown1}
    //       onChange={(e) => setDropdown1(e.target.value)}
    //       disabled={disabled}
    //       sx={{
    //         fontSize: '0.8rem !important',
    //         '& .MuiOutlinedInput-input': {
    //           padding: '8px 31px 8px 12px !important',
    //         },
    //       }}
    //     >
    //       <MenuItem value='MINOR INJURY' sx={{ fontSize: '0.8rem' }}>
    //         MINOR INJURY
    //       </MenuItem>
    //       <MenuItem value='MAJOR INJURY' sx={{ fontSize: '0.8rem' }}>
    //         MAJOR INJURY
    //       </MenuItem>
    //       <MenuItem value='RESPONSIVE' sx={{ fontSize: '0.8rem' }}>
    //         RESPONSIVE
    //       </MenuItem>
    //       <MenuItem value='NOT RESPONSIVE' sx={{ fontSize: '0.8rem' }}>
    //         NOT RESPONSIVE
    //       </MenuItem>
    //     </Select>
    //   </FormControl>

    //   {/* Dropdown 2 */}
    //   <FormControl
    //     size='small'
    //     sx={{
    //       minWidth: 110,
    //       '& .MuiOutlinedInput-root': {
    //         borderRadius: '25px',
    //         backgroundColor: '#fff',
    //       },
    //     }}
    //   >
    //     {!dropdown2 && (
    //       <InputLabel
    //         id='dropdown2-label'
    //         sx={{
    //           top: '-2px',
    //           left: '5px',
    //           fontSize: '0.875rem',
    //         }}
    //       >
    //         Option 2
    //       </InputLabel>
    //     )}
    //     <Select
    //       labelId='dropdown2-label'
    //       value={dropdown2}
    //       onChange={(e) => {
    //         setDropdown2(e.target.value);
    //         gpsUnitMedical();
    //       }}
    //       disabled={disabled}
    //       sx={{
    //         fontSize: '0.8rem !important',
    //         '& .MuiOutlinedInput-input': {
    //           padding: '8px 31px 8px 12px !important',
    //         },
    //       }}
    //     >
    //       <MenuItem value='SHIFTED TO BASECAMP' sx={{ fontSize: '0.8rem' }}>
    //         SHIFTED TO BASECAMP
    //       </MenuItem>
    //       <MenuItem value='SHIFTED TO HOSPITAL' sx={{ fontSize: '0.8rem' }}>
    //         SHIFTED TO HOSPITAL
    //       </MenuItem>
    //     </Select>
    //   </FormControl>

    //   {/* Dropdown 3 */}
    //   {dropdown2 === 'SHIFTED TO HOSPITAL' && !isEmpty(medicalList) && (
    //     <FormControl
    //       size='small'
    //       sx={{
    //         minWidth: 110,
    //         '& .MuiOutlinedInput-root': {
    //           borderRadius: '25px',
    //           backgroundColor: '#fff',
    //         },
    //       }}
    //     >
    //       {!dropdown3 && (
    //         <InputLabel
    //           id='dropdown3-label'
    //           sx={{
    //             top: '-2px',
    //             left: '5px',
    //             fontSize: '0.875rem',
    //           }}
    //         >
    //           Option 3
    //         </InputLabel>
    //       )}
    //       <Select
    //         labelId='dropdown3-label'
    //         value={dropdown3}
    //         onChange={(e) => setDropdown3(e.target.value)}
    //         disabled={disabled}
    //         sx={{
    //           fontSize: '0.8rem !important',
    //           '& .MuiOutlinedInput-input': {
    //             padding: '8px 31px 8px 12px !important',
    //           },
    //         }}
    //       >
    //         {map(medicalList, (item) => {
    //           return (
    //             <MenuItem value={item?.name} sx={{ fontSize: '0.8rem' }}>
    //               {item?.name}
    //             </MenuItem>
    //           );
    //         })}
    //       </Select>
    //     </FormControl>
    //   )}

    //   {/* Text input */}
    //   <Box
    //     component='input'
    //     placeholder='Type a message'
    //     value={text}
    //     onChange={(e) => setText(e.target.value)}
    //     onKeyDown={(e) => e.key === 'Enter' && send()}
    //     sx={{
    //       flex: 1,
    //       border: 'none',
    //       outline: 'none',
    //       px: 2,
    //       py: 1.2,
    //       mr: 1,
    //       borderRadius: 25,
    //       fontSize: '0.95rem',
    //       backgroundColor: '#fff',
    //       boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
    //     }}
    //   />

    //   {/* Send button */}
    //   <IconButton
    //     onClick={send}
    //     disabled={disabled}
    //     sx={{
    //       bgcolor: '#006a4e',
    //       color: '#fff',
    //       width: 45,
    //       height: 45,
    //       '&:hover': { bgcolor: '#006a4e' },
    //     }}
    //   >
    //     <MdSend size={22} />
    //   </IconButton>
    // </Paper>

    isMobile ? (
      <Paper
        elevation={3}
        sx={{
          p: { xs: 0.5, sm: 1, md: 1.5 },
          display: 'flex',
          alignItems: { xs: 'stretch', sm: 'center' },
          bgcolor: '#f0f0f0',
          flexWrap: 'wrap',
          gap: { xs: 0.5, sm: 1 },
          flexDirection: { xs: 'column', sm: 'row' },
          borderRadius: { xs: 1, sm: 2 },
          // Add bottom padding to prevent overlap with fixed input
          paddingBottom: { xs: '80px', sm: 1.5 }, // Account for fixed input height
          marginBottom: { xs: 0, sm: 0 },
        }}
      >
        {/* Attachments preview */}

        {/* Camera + Dropdown1 Row for mobile */}
        {/* <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            flexWrap: 'nowrap',
            width: '100%',
            order: { xs: 2, sm: 0 },
            alignItems: 'center',
            minWidth: 0,
            position: 'relative', // Establish stacking context
            zIndex: 1, // Ensure it's above other content but below modals
          }}
        > */}
        {/* <input
            type='file'
            id='fileInput'
            accept='image/*'
            capture
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          <IconButton
            component='label'
            htmlFor='fileInput'
            sx={{
              color: '#555',
              p: { xs: 0.5, sm: 1 },
              flexShrink: 0,
              alignSelf: 'center',
            }}
          >
            {uploading ? (
              <CircularProgress size={20} />
            ) : (
              <MdCameraAlt size={22} />
            )}
          </IconButton> */}

        {/* </Box> */}

        {/* Dropdown2 + Dropdown3 */}
        {/* <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            flexWrap: 'nowrap',
            width: '100%',
            order: { xs: 3, sm: 0 },
            alignItems: 'center',
            minWidth: 0,
            position: 'relative', // Establish stacking context
            zIndex: 1, // Ensure it's above other content but below modals
          }}
        >
    
        </Box> */}

        {/* Text input + Send button Row for mobile */}
        <Box
          sx={{
            display: 'flex',
            gap: 0.5,
            width: '100%',
            order: { xs: 4, sm: 0 },
            // alignItems: 'center',
            flexWrap: 'nowrap',
            position: { xs: 'fixed', sm: 'static' }, // Only fixed on mobile
            bottom: { xs: 0, sm: 'auto' },
            left: { xs: 0, sm: 'auto' },
            right: { xs: 0, sm: 'auto' },
            padding: { xs: '8px', sm: 0 },
            backgroundColor: { xs: '#fff', sm: 'transparent' },
            boxShadow: { xs: '0 -2px 10px rgba(0,0,0,0.1)', sm: 'none' },
            zIndex: 1000, // Lower than dropdown menus
            px: 2,
            flexDirection: 'column',
          }}
        >
          {attachments.length > 0 && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                gap: { xs: 0.5, sm: 1 },
                flexWrap: 'wrap',
                px: { xs: 0.5, sm: 1 },
                maxHeight: { xs: 60, sm: 'none' },
                overflow: { xs: 'auto', sm: 'visible' },
              }}
            >
              {attachments.map((file, idx) => (
                <Box
                  key={idx}
                  sx={{
                    position: 'relative',
                    width: { xs: 40, sm: 50, md: 60 },
                    height: { xs: 40, sm: 50, md: 60 },
                    borderRadius: { xs: 1, sm: 2 },
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#fafafa',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': {
                      transform: { xs: 'none', sm: 'scale(1.05)' },
                      boxShadow: {
                        xs: '0 1px 3px rgba(0,0,0,0.1)',
                        sm: '0 3px 6px rgba(0,0,0,0.15)',
                      },
                    },
                  }}
                >
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${file}`}
                    alt={file}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                  <IconButton
                    size='small'
                    onClick={() => removeAttachment(idx)}
                    sx={{
                      position: 'absolute',
                      top: { xs: 2, sm: 4 },
                      right: { xs: 2, sm: 4 },
                      bgcolor: 'rgba(255,255,255,0.8)',
                      color: '#333',
                      width: { xs: 18, sm: 22 },
                      height: { xs: 18, sm: 22 },
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      p: 0,
                      fontSize: { xs: '0.7rem', sm: '0.8rem' },
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,1)',
                        color: '#d32f2f',
                      },
                    }}
                  >
                    ✕
                  </IconButton>
                </Box>
              ))}
            </Box>
          )}
          <Box sx={{ width: '100%', alignItems: 'center', display: 'flex' }}>
            {openCamera ? (
              <FullScreenCamera
                onClose={() => setOpenCamera(false)}
                onCapture={capturePhoto} // uploads file
                uploading={uploading}
                webcamRef={webcamRef}
                loading={loading}
              />
            ) : (
              <IconButton
                onClick={() => setOpenCamera(true)}
                sx={{
                  color: '#555',
                  alignSelf: { xs: 'flex-start', sm: 'center' },
                  p: '6px 0px 0px 0px',
                }}
              >
                {uploading ? <CircularProgress /> : <MdCameraAlt />}
              </IconButton>
            )}

            <FormControl
              variant='outlined'
              size='small'
              sx={{
                minWidth: dropdown1 ? 'fit-content' : 110,
                marginRight: '15px',
                flex: '1 1 0%',
                '& .MuiOutlinedInput-root': {
                  borderRadius: { xs: '15px', sm: '25px' },
                  backgroundColor: '#fff',
                  '& fieldset': {
                    top: 0,
                  },
                },
              }}
            >
              {!dropdown1 && (
                <InputLabel
                  id='dropdown1-label'
                  sx={{
                    top: '-1px',
                    left: '5px',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  }}
                >
                  OPTION 1
                </InputLabel>
              )}
              <Select
                labelId='dropdown1-label'
                value={dropdown1}
                onChange={(e) => setDropdown1(e.target.value)}
                disabled={disabled}
                label={!dropdown1 ? 'Option 1' : ''}
                MenuProps={{
                  sx: {
                    zIndex: 1300, // Higher than fixed input (1000)
                    '& .MuiPaper-root': {
                      maxHeight: '200px',
                      zIndex: 1300,
                    },
                  },
                }}
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 30px 8px 14px !important',
                  },
                  '& legend': {
                    display: dropdown1 ? 'none' : 'flex',
                  },
                }}
              >
                <MenuItem
                  value='MINOR INJURY'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  MINOR INJURY
                </MenuItem>
                <MenuItem
                  value='MAJOR INJURY'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  MAJOR INJURY
                </MenuItem>
                <MenuItem
                  value='RESPONSIVE'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  RESPONSIVE
                </MenuItem>
                <MenuItem
                  value='NOT RESPONSIVE'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  NOT RESPONSIVE
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box
            sx={{
              width: '100%',
              alignItems: 'center',
              display: 'flex',
              marginRight: '15px',
            }}
          >
            <FormControl
              size='small'
              sx={{
                minWidth: dropdown2 ? 'fit-content' : 110,
                flex: '1 1 0%',
                marginRight: dropdown2 === 'SHIFTED TO HOSPITAL' ? 0 : '15px',
                maxWidth: '100%',
                '& .MuiOutlinedInput-root': {
                  borderRadius: { xs: '15px', sm: '25px' },
                  backgroundColor: '#fff',
                },
                '& fieldset': {
                  top: 0,
                },
              }}
            >
              {!dropdown2 && (
                <InputLabel
                  id='dropdown2-label'
                  sx={{
                    top: '-1px',
                    left: '5px',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  }}
                >
                  OPTION 2
                </InputLabel>
              )}
              <Select
                labelId='dropdown2-label'
                value={dropdown2}
                onChange={(e) => {
                  setDropdown2(e.target.value);
                  // gpsUnitMedical();
                }}
                disabled={disabled}
                label={!dropdown2 ? 'Option 2' : ''}
                MenuProps={{
                  sx: {
                    zIndex: 1300, // Higher than fixed input (1000)
                    '& .MuiPaper-root': {
                      maxHeight: '200px',
                      zIndex: 1300,
                    },
                  },
                }}
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 30px 8px 14px !important',
                  },
                  '& legend': {
                    display: dropdown2 ? 'none' : 'block',
                  },
                }}
              >
                <MenuItem
                  value='SHIFTED TO BASECAMP'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  SHIFTED TO BASECAMP
                </MenuItem>
                <MenuItem
                  value='SHIFTED TO HOSPITAL'
                  sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                >
                  SHIFTED TO HOSPITAL
                </MenuItem>
              </Select>
            </FormControl>

            {dropdown2 === 'SHIFTED TO HOSPITAL' && !isEmpty(medicalList) && (
              <FormControl
                size='small'
                sx={{
                  minWidth: dropdown3 ? 'fit-content' : 110,
                  flex: '1 1 0%',
                  maxWidth: '100%',
                  ml: 0.5,
                  marginRight: '15px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: { xs: '15px', sm: '25px' },
                    backgroundColor: '#fff',
                  },
                  '& fieldset': {
                    top: 0,
                  },
                }}
              >
                {!dropdown3 && (
                  <InputLabel
                    id='dropdown3-label'
                    sx={{
                      top: '-1px',
                      left: '5px',
                      fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    }}
                  >
                    OPTION 3
                  </InputLabel>
                )}
                <Select
                  labelId='dropdown3-label'
                  value={dropdown3}
                  onChange={(e) => setDropdown3(e.target.value)}
                  label={!dropdown3 ? 'Option 3' : ''}
                  disabled={disabled}
                  MenuProps={{
                    sx: {
                      zIndex: 1300, // Higher than fixed input (1000)
                      '& .MuiPaper-root': {
                        maxHeight: '200px',
                        zIndex: 1300,
                      },
                    },
                  }}
                  sx={{
                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 30px 8px 14px !important',
                    },
                    '& legend': {
                      display: dropdown3 ? 'none' : 'block',
                    },
                  }}
                >
                  {map(medicalList, (item) => {
                    return (
                      <MenuItem
                        key={item?.name}
                        value={item?.name}
                        sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                      >
                        {item?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
          </Box>
          <Box
            sx={{
              width: '100%',
              alignItems: 'center',
              display: 'flex',
              gap: 1,
            }}
          >
            <input
              placeholder='Type a message'
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && send()}
              style={{
                flex: '1 1 0%',
                minWidth: 0,
                border: '1px solid #d6d6d6',
                outline: 'none',
                padding: window.innerWidth < 600 ? '8px 12px' : '10px 15px',
                borderRadius: window.innerWidth < 600 ? '20px' : '25px',
                fontSize: window.innerWidth < 600 ? '16px' : '0.95rem',
                backgroundColor: '#fff',
                boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
              }}
            />
            <IconButton
              onClick={send}
              disabled={disabled}
              sx={{
                flexShrink: 0,
                bgcolor: '#006a4e',
                color: '#fff',
                width: { xs: 36, sm: 45 },
                height: { xs: 36, sm: 45 },
                minWidth: { xs: 36, sm: 45 },
                marginRight: '15px',
                '&:hover': { bgcolor: '#006a4e' },
                '&:disabled': { bgcolor: '#cccccc' },
                borderRadius: '50%',
              }}
            >
              <MdSend style={{ width: 14, height: 14, display: 'block' }} />
            </IconButton>
          </Box>

          <Grid
            container
            spacing={1}
            sx={{ m: 0, width: 'calc(100% + -16px)' }}
          >
            {map(medicalList, (data, index) => (
              <Grid item xs={4} key={index} sx={{ p: '0px !important' }}>
                <Card sx={{ padding: 0.3 }}>
                  <Button
                    variant='contained'
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      fontSize: '0.6rem',
                    }}
                    color='error'
                    onClick={() => {
                      const androidUrl = `https://www.google.com/maps/search/?api=1&query=${data?.latitude},${data?.longitude}`;
                      window.location.href = androidUrl;
                    }}
                  >
                    {data?.name}
                  </Button>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Paper>
    ) : (
      <Paper
        elevation={3}
        sx={{
          p: { xs: 0.5, sm: 1, md: 1.5 },
          display: 'flex',
          alignItems: { xs: 'stretch', sm: 'center' },
          bgcolor: '#f0f0f0',
          flexWrap: 'wrap',
          gap: { xs: 0.5, sm: '5px' },
          flexDirection: { xs: 'column', sm: 'row' },
          borderRadius: { xs: 1, sm: 2 },
        }}
      >
        {/* Attachments preview */}
        {attachments.length > 0 && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              gap: { xs: 0.5, sm: 1 },
              flexWrap: 'wrap',
              px: { xs: 0.5, sm: 1 },
              order: { xs: 1, sm: 0 },
              maxHeight: { xs: 60, sm: 'none' },
              overflow: { xs: 'auto', sm: 'visible' },
            }}
          >
            {attachments.map((file, idx) => {
              return (
                <Box
                  key={idx}
                  sx={{
                    position: 'relative',
                    width: { xs: 40, sm: 50, md: 60 },
                    height: { xs: 40, sm: 50, md: 60 },
                    borderRadius: { xs: 1, sm: 2 },
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: '#fafafa',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    transition: 'transform 0.2s ease-in-out',
                    '&:hover': {
                      transform: { xs: 'none', sm: 'scale(1.05)' },
                      boxShadow: {
                        xs: '0 1px 3px rgba(0,0,0,0.1)',
                        sm: '0 3px 6px rgba(0,0,0,0.15)',
                      },
                    },
                  }}
                >
                  {/* Image */}
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL}/images/${file}`}
                    alt={file}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: 'inherit',
                    }}
                  />

                  {/* Remove icon */}
                  <IconButton
                    size='small'
                    onClick={() => removeAttachment(idx)}
                    sx={{
                      position: 'absolute',
                      top: { xs: 2, sm: 4 },
                      right: { xs: 2, sm: 4 },
                      bgcolor: 'rgba(255,255,255,0.8)',
                      color: '#333',
                      width: { xs: 18, sm: 22 },
                      height: { xs: 18, sm: 22 },
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      p: 0,
                      fontSize: { xs: '0.7rem', sm: '0.8rem' },
                      '&:hover': {
                        bgcolor: 'rgba(255,255,255,1)',
                        color: '#d32f2f',
                      },
                    }}
                  >
                    ✕
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        )}

        {/* Camera/File input */}
        {/* <input
          type='file'
          id='fileInput'
          accept='image/*'
          capture
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />

        <IconButton
          component='label'
          htmlFor='fileInput'
          sx={{
            color: '#555',
            order: { xs: 2, sm: 0 },
            alignSelf: { xs: 'flex-start', sm: 'center' },
            p: { xs: 0, sm: 0 },
          }}
        >
          {uploading ? <CircularProgress /> : <MdCameraAlt />}
        </IconButton> */}

        {openCamera ? (
          <FullScreenCamera
            onClose={() => setOpenCamera(false)}
            onCapture={capturePhoto} // uploads file
            uploading={uploading}
            webcamRef={webcamRef}
            loading={loading}
          />
        ) : (
          <IconButton
            onClick={() => setOpenCamera(true)}
            sx={{
              color: '#555',
              order: { xs: 2, sm: 0 },
              alignSelf: { xs: 'flex-start', sm: 'center' },
              p: { xs: 0, sm: 0 },
            }}
          >
            {uploading ? <CircularProgress /> : <MdCameraAlt />}
          </IconButton>
        )}

        {/* Dropdowns Container */}
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 0.5, sm: '5px' },
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            width: { xs: '100%', sm: 'auto' },
            order: { xs: 3, sm: 0 },
          }}
        >
          {/* Dropdown 1 */}
          <FormControl
            variant='outlined'
            size='small'
            sx={{
              minWidth: dropdown1 ? 'fit-content' : 110,
              flex: { xs: '1 1 48%', sm: '0 0 auto' },
              '& .MuiOutlinedInput-root': {
                borderRadius: { xs: '15px', sm: '25px' },
                '& fieldset': {
                  top: 0,
                },
              },
            }}
          >
            {!dropdown1 && (
              <InputLabel
                id='dropdown1-label'
                sx={{
                  top: '-1px',
                  left: '5px',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                }}
              >
                OPTION 1
              </InputLabel>
            )}
            <Select
              labelId='dropdown1-label'
              value={dropdown1}
              onChange={(e) => setDropdown1(e.target.value)}
              disabled={disabled}
              // Conditionally add label prop - only when no value selected
              label={!dropdown1 ? 'Option 1' : ''}
              sx={{
                fontSize: { xs: '0.7rem', sm: '0.8rem' },
                '& .MuiOutlinedInput-input': {
                  padding: '8px 30px 8px 14px !important',
                },
                // Conditionally hide the legend when value is selected
                '& legend': {
                  display: dropdown1 ? 'none' : 'flex',
                },
              }}
            >
              <MenuItem
                value='MINOR INJURY'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                MINOR INJURY
              </MenuItem>
              <MenuItem
                value='MAJOR INJURY'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                MAJOR INJURY
              </MenuItem>
              <MenuItem
                value='RESPONSIVE'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                RESPONSIVE
              </MenuItem>
              <MenuItem
                value='NOT RESPONSIVE'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                NOT RESPONSIVE
              </MenuItem>
            </Select>
          </FormControl>

          {/* Dropdown 2 */}
          <FormControl
            size='small'
            sx={{
              minWidth: dropdown2 ? 'fit-content' : 110,
              flex: { xs: '1 1 48%', sm: '0 0 auto' },
              '& .MuiOutlinedInput-root': {
                borderRadius: { xs: '15px', sm: '25px' },
              },
              '& fieldset': {
                // Add this
                top: 0,
              },
            }}
          >
            {!dropdown2 && (
              <InputLabel
                id='dropdown2-label'
                sx={{
                  top: '-1px',
                  left: '5px',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                }}
              >
                OPTION 2
              </InputLabel>
            )}
            <Select
              labelId='dropdown2-label'
              value={dropdown2}
              onChange={(e) => {
                setDropdown2(e.target.value);
                gpsUnitMedical();
              }}
              disabled={disabled}
              label={!dropdown2 ? 'Option 2' : ''}
              sx={{
                fontSize: { xs: '0.7rem', sm: '0.8rem' },
                '& .MuiOutlinedInput-input': {
                  padding: '8px 30px 8px 14px !important',
                },
                // '& legend': {
                //   display: dropdown2 ? 'none' : 'flex',
                // },
              }}
            >
              <MenuItem
                value='SHIFTED TO BASECAMP'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                SHIFTED TO BASECAMP
              </MenuItem>
              <MenuItem
                value='SHIFTED TO HOSPITAL'
                sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
              >
                SHIFTED TO HOSPITAL
              </MenuItem>
            </Select>
          </FormControl>

          {/* Dropdown 3 */}
          {dropdown2 === 'SHIFTED TO HOSPITAL' && !isEmpty(medicalList) && (
            <FormControl
              size='small'
              sx={{
                minWidth: dropdown3 ? 'fit-content' : 110,
                flex: { xs: '1 1 100%', sm: '0 0 auto' },
                '& .MuiOutlinedInput-root': {
                  borderRadius: { xs: '15px', sm: '25px' },
                  // backgroundColor: '#fff',
                },
                '& fieldset': {
                  // Add this
                  top: 0,
                },
              }}
            >
              {!dropdown3 && (
                <InputLabel
                  id='dropdown3-label'
                  sx={{
                    top: '-1px',
                    left: '5px',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  }}
                >
                  OPTION 3
                </InputLabel>
              )}
              <Select
                labelId='dropdown3-label'
                value={dropdown3}
                onChange={(e) => setDropdown3(e.target.value)}
                label={!dropdown3 ? 'Option 3' : ''}
                disabled={disabled}
                sx={{
                  fontSize: { xs: '0.7rem', sm: '0.8rem' },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 30px 8px 14px !important',
                  },
                  '& legend': {
                    display: dropdown2 ? 'none' : 'block',
                  },
                }}
              >
                {map(medicalList, (item) => {
                  return (
                    <MenuItem
                      key={item?.name}
                      value={item?.name}
                      sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
                    >
                      {item?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </Box>

        {/* Text input */}
        <Box
          component='input'
          placeholder='Type a message'
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && send()}
          sx={{
            flex: { xs: '1 1 100%', sm: 1 },
            border: 'none',
            outline: 'none',
            px: { xs: 1.5, sm: 2 },
            py: { xs: 1, sm: 1.2 },
            mr: { xs: 0, sm: 1 },
            borderRadius: { xs: 15, sm: 25 },
            fontSize: { xs: '0.85rem', sm: '0.95rem' },
            backgroundColor: '#fff',
            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
            order: { xs: 4, sm: 0 },
            border: '1px solid #d6d6d6',
          }}
        />

        {/* Send button */}
        {/* <IconButton
          onClick={send}
          disabled={disabled}
          sx={{
            bgcolor: '#006a4e',
            color: '#fff',
            width: { xs: 38, sm: 45 },
            height: { xs: 38, sm: 45 },
            alignSelf: { xs: 'flex-end', sm: 'center' },
            order: { xs: 4, sm: 0 },
            mt: { xs: 1, sm: 0 },
            '&:hover': { bgcolor: '#006a4e' },
            '&:disabled': { bgcolor: '#cccccc' },
          }}
        >
          <MdSend size={{ xs: 18, sm: 22 }} />
        </IconButton> */}

        <Box
          sx={{
            p: 0,
            borderRadius: 2,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            transition: 'all 0.2s',
            mr: '0.8rem',
            '&:hover': {
              bgcolor: '#e4e4e4',
            },
          }}
        >
          <Checkbox
            checked={allSelected}
            onChange={toggleSelectAll}
            sx={{
              color: 'default',
              color: 'red',
              pl: 0,
            }}
          />
          <Typography
            variant='body1'
            sx={{
              flex: 1,
              fontWeight: 500,
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              fontSize: '0.8rem',
              color: 'red',
            }}
          >
            BROADCAST
          </Typography>
        </Box>

        <IconButton
          onClick={send}
          disabled={disabled}
          sx={{
            bgcolor: '#006a4e',
            color: '#fff',
            width: { xs: 38, sm: 45 },
            height: { xs: 38, sm: 45 },
            alignSelf: { xs: 'flex-end', sm: 'center' },
            order: { xs: 4, sm: 0 },
            mt: { xs: 1, sm: 0 },
            '&:hover': { bgcolor: '#006a4e' },
            '&:disabled': { bgcolor: '#cccccc' },
            borderRadius: '50%', // force circle on iOS
          }}
        >
          <MdSend
            style={{
              width: window.innerWidth < 600 ? 14 : 22,
              height: window.innerWidth < 600 ? 14 : 22,
              display: 'block', // removes inline SVG gap on Safari
            }}
          />
        </IconButton>
      </Paper>
    )
  );
};

// export const FullScreenCamera = ({
//   onClose,
//   onCapture,
//   loading,
//   webcamRef,
// }) => {
//   const [facingMode, setFacingMode] = useState('environment');
//   const [preview, setPreview] = useState(null);

//   const capturePhoto = async () => {
//     if (!webcamRef.current) return;
//     const imageSrc = webcamRef.current.getScreenshot();
//     if (!imageSrc) return;
//     setPreview(imageSrc);
//     sendPhoto(imageSrc);
//   };

//   const sendPhoto = (imageSrc) => {
//     if (!imageSrc) return;
//     const file = dataURLtoFile(imageSrc, `photo_${Date.now()}.jpg`);
//     onCapture(file);
//   };

//   const dataURLtoFile = (dataurl, filename) => {
//     const arr = dataurl.split(',');
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     while (n--) u8arr[n] = bstr.charCodeAt(n);
//     return new File([u8arr], filename, { type: mime });
//   };

//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100vw',
//         height: '100vh',
//         bgcolor: 'black',
//         zIndex: 2000,
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       <Backdrop sx={{ color: '#fff', zIndex: 13000 }} open={loading}>
//         <CircularProgress color='inherit' />
//       </Backdrop>

//       {/* Close button */}
//       <IconButton
//         onClick={onClose}
//         sx={{
//           position: 'absolute',
//           top: `calc(16px + env(safe-area-inset-top))`,
//           left: 16,
//           color: 'white',
//           zIndex: 2100,
//         }}
//       >
//         <MdClose size={28} />
//       </IconButton>

//       <Box
//         sx={{
//           position: 'relative',
//           width: '100%',
//           height: '100vh',
//           bgcolor: 'black',
//         }}
//       >
//         <Webcam
//           ref={webcamRef}
//           screenshotFormat='image/jpeg'
//           videoConstraints={{ facingMode }}
//           style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//         />

//         {/* Capture button - Fixed for Safari footer overlap */}
//         <IconButton
//           onClick={capturePhoto}
//           sx={{
//             position: 'absolute',
//             // Use max() to ensure minimum 100px spacing on Safari
//             bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
//             left: '50%',
//             transform: 'translateX(-50%)',
//             bgcolor: 'white',
//             width: 64,
//             height: 64,
//             borderRadius: '50%',
//             zIndex: 10,
//             boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
//             '&:hover': { bgcolor: '#ddd' },
//             WebkitTouchCallout: 'none',
//             WebkitUserSelect: 'none',
//             // Safari-specific hack
//             '@supports (-webkit-touch-callout: none)': {
//               bottom: `calc(100px + env(safe-area-inset-bottom))`,
//             },
//           }}
//         >
//           <MdCameraAlt size={32} />
//         </IconButton>

//         {/* Flip camera button - Also updated */}
//         <IconButton
//           onClick={() =>
//             setFacingMode((prev) =>
//               prev === 'environment' ? 'user' : 'environment'
//             )
//           }
//           sx={{
//             position: 'absolute',
//             bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
//             right: 32,
//             color: 'white',
//             bgcolor: 'rgba(0,0,0,0.4)',
//             zIndex: 10,
//             '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
//             '@supports (-webkit-touch-callout: none)': {
//               bottom: `calc(100px + env(safe-area-inset-bottom))`,
//             },
//           }}
//         >
//           <MdFlipCameraAndroid size={32} />
//         </IconButton>
//       </Box>
//     </Box>
//   );
// };

export const FullScreenCamera = ({
  onClose,
  onCapture,
  loading,
  webcamRef,
}) => {
  const [facingMode, setFacingMode] = useState('environment');
  const [preview, setPreview] = useState(null);

  const capturePhoto = async () => {
    if (!webcamRef.current) return;
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;
    setPreview(imageSrc);
    sendPhoto(imageSrc);
  };

  const sendPhoto = (imageSrc) => {
    if (!imageSrc) return;
    const file = dataURLtoFile(imageSrc, `photo_${Date.now()}.jpg`);
    onCapture(file);
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'black',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Backdrop sx={{ color: '#fff', zIndex: 13000 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>

      {/* Close button */}
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: `calc(16px + env(safe-area-inset-top))`, // Add top safe area
          left: 16,
          color: 'white',
          zIndex: 2100,
        }}
      >
        <MdClose size={28} />
      </IconButton>

      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100vh',
          bgcolor: 'black',
        }}
      >
        <Webcam
          ref={webcamRef}
          screenshotFormat='image/jpeg'
          videoConstraints={{ facingMode }}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <IconButton
          onClick={capturePhoto}
          sx={{
            position: 'absolute',
            // Use max() to ensure minimum 100px spacing on Safari
            bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'white',
            width: 64,
            height: 64,
            borderRadius: '50%',
            zIndex: 10,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            '&:hover': { bgcolor: '#ddd' },
            WebkitTouchCallout: 'none',
            WebkitUserSelect: 'none',
            // Safari-specific hack
            '@supports (-webkit-touch-callout: none)': {
              bottom: `calc(100px + env(safe-area-inset-bottom))`,
            },
          }}
        >
          <MdCameraAlt size={32} />
        </IconButton>

        {/* Flip camera button - Also updated */}
        <IconButton
          onClick={() =>
            setFacingMode((prev) =>
              prev === 'environment' ? 'user' : 'environment'
            )
          }
          sx={{
            position: 'absolute',
            bottom: `max(100px, calc(40px + env(safe-area-inset-bottom)))`,
            right: 32,
            color: 'white',
            bgcolor: 'rgba(0,0,0,0.4)',
            zIndex: 10,
            '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
            '@supports (-webkit-touch-callout: none)': {
              bottom: `calc(100px + env(safe-area-inset-bottom))`,
            },
          }}
        >
          <MdFlipCameraAndroid size={32} />
        </IconButton>
      </Box>
    </Box>
  );
};

// export const FullScreenCamera = ({
//   onClose,
//   onCapture,
//   loading,
//   webcamRef,
// }) => {
//   const [facingMode, setFacingMode] = useState('environment');
//   const [preview, setPreview] = useState(null);

//   console.log('preview', preview);

//   const capturePhoto = async () => {
//     if (!webcamRef.current) return;
//     const imageSrc = webcamRef.current.getScreenshot();
//     if (!imageSrc) return;
//     setPreview(imageSrc);
//     sendPhoto(imageSrc);
//   };

//   const sendPhoto = (imageSrc) => {
//     if (!imageSrc) return;
//     const file = dataURLtoFile(imageSrc, `photo_${Date.now()}.jpg`);
//     console.log('file', file);
//     onCapture(file);
//   };

//   const dataURLtoFile = (dataurl, filename) => {
//     const arr = dataurl.split(',');
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     while (n--) u8arr[n] = bstr.charCodeAt(n);
//     return new File([u8arr], filename, { type: mime });
//   };

//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100vw',
//         height: '100vh',
//         bgcolor: 'black',
//         zIndex: 2000,
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       <Backdrop
//         sx={{ color: '#fff', zIndex: 13000 }} // high zIndex to cover everything
//         open={loading} // show when loading is true
//       >
//         <CircularProgress color='inherit' />
//       </Backdrop>

//       {/* Close button */}
//       <IconButton
//         onClick={onClose}
//         sx={{
//           position: 'absolute',
//           top: 16,
//           left: 16,
//           color: 'white',
//           zIndex: 2100,
//         }}
//       >
//         <MdClose size={28} />
//       </IconButton>

//       <Box
//         sx={{
//           position: 'relative',
//           width: '100%',
//           height: '100vh',
//           bgcolor: 'black',
//         }}
//       >
//         <Webcam
//           ref={webcamRef}
//           screenshotFormat='image/jpeg'
//           videoConstraints={{ facingMode }}
//           style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//         />

//         {/* Capture button overlay */}
//         <IconButton
//           onClick={capturePhoto}
//           sx={{
//             position: 'absolute',
//             bottom: 40, // distance from bottom
//             left: '50%', // center horizontally
//             transform: 'translateX(-50%)',
//             bgcolor: 'white',
//             width: 64,
//             height: 64,
//             borderRadius: '50%',
//             zIndex: 10,
//             '&:hover': { bgcolor: '#ddd' },
//           }}
//         >
//           {/* <MdCameraAlt size={32} /> */}
//         </IconButton>

//         {/* Flip camera button */}
//         <IconButton
//           onClick={() =>
//             setFacingMode((prev) =>
//               prev === 'environment' ? 'user' : 'environment'
//             )
//           }
//           sx={{
//             position: 'absolute',
//             bottom: 40,
//             right: 32,
//             color: 'white',
//             bgcolor: 'rgba(0,0,0,0.4)',
//             zIndex: 10,
//             '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
//           }}
//         >
//           <MdFlipCameraAndroid size={32} />
//         </IconButton>
//       </Box>

//       {/* Camera or preview */}
//       {/* <Box sx={{ flex: 1 }}>
//         {!preview ? (
//           <Webcam
//             ref={webcamRef}
//             screenshotFormat='image/jpeg'
//             videoConstraints={{ facingMode }}
//             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//           />
//         ) : (
//           <img
//             src={preview}
//             alt='Preview'
//             style={{ width: '100%', height: '100%', objectFit: 'contain' }}
//           />
//         )}
//       </Box> */}

//       {/* Controls */}
//       {/* <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           gap: 2,
//           alignItems: 'center',
//           py: 2,
//           bgcolor: 'rgba(0,0,0,0.6)',
//         }}
//       >
//         {!preview ? (
//           <>
//             <IconButton
//               onClick={() =>
//                 setFacingMode((prev) =>
//                   prev === 'environment' ? 'user' : 'environment'
//                 )
//               }
//               sx={{ color: 'white' }}
//             >
//               <MdFlipCameraAndroid size={32} />
//             </IconButton>

//             <IconButton
//               onClick={capturePhoto}
//               sx={{
//                 bgcolor: 'white',
//                 width: 64,
//                 height: 64,
//                 borderRadius: '50%',
//                 '&:hover': { bgcolor: '#ddd' },
//               }}
//             >
//               <MdCameraAlt size={32} />
//             </IconButton>
//           </>
//         ) : (
//           <>
//             <Button
//               variant='outlined'
//               color='error'
//               onClick={() => setPreview(null)}
//             >
//               Retake
//             </Button>
//             <Button
//               variant='contained'
//               color='success'
//               onClick={sendPhoto}
//               disabled={uploading}
//             >
//               {uploading ? 'Sending...' : 'Send'}
//             </Button>
//           </>
//         )}
//       </Box> */}
//     </Box>
//   );
// };
